<template>
  <div>
    <div id="productDetail">
      <div class="divisions">
        <img :src="this.product.img" />
      </div>
      <div class="divisions" id="productDetails">
        <h2 id="name">{{ this.product.class }}</h2>
        <p id="details">{{ this.product.text }}</p>

        <h3 id="price">
          {{ this.product.price }}
          <small>Inclusive of all taxes</small>
          <button>Buy Now</button>
        </h3>
        <h4>Contents</h4>
        <ol id="contentsList">
          <li
            v-for="(content, index) in this.product.data.contents"
            :key="index"
          >
            {{ content }}
          </li>
          <li></li>
        </ol>

        <p
          v-for="(text, index) in this.product.data.others"
          :key="index"
          class="othersList"
        >
          {{ text }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import productsData from "@/assets/data/productsList.js";
export default {
  name: "ProductDetail",
  data() {
    return {
      product: {
        price: "hiii",
        class: "",
        img: "",
        text: "",
        contents: {},
        others: {}
      }
    };
  },
  mounted() {
    var productId = this.$route.params.productId;
    var productSelected = productsData.filter(function(obj) {
      return obj.id === parseInt(productId);
    });
    this.product = productSelected[0];
  }
};
</script>

<style lang="scss" scoped>
#productDetail {
  display: flex;
  flex-direction: column;
  @include media-md {
    flex-direction: row;
  }
  .divisions {
    width: 100%;
    padding: 15px;
    align-self: flex-start;
    @include media-md {
      width: 50%;
    }
  }
  img {
    padding-top: 0;
    width: 80%;
  }
  #productDetails {
    #name {
      font-weight: 400;
    }
    #details {
    }
    #price {
      small {
        display: block;
        font-weight: 400;
        font-size: 0.8rem;
      }
    }
    #contentsList {
      margin-left: 1rem;
      font-size: 0.9rem;
      list-style: none;
    }
    h4 {
      margin: 0.25rem 0;
    }
    .othersList {
      margin: 0.25rem 0;
    }
  }
}
</style>
